module.exports = __webpack_public_path__ + "static/img/m_2.5621b168.jpg";